import * as types from './types';

export const setSelectedTab = value => {
  return {
    type: types.TRUCK_ROUTE_SET_SELECTED_TAB,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/settings/actions.js